import React from "react";

const Toggle = ({ enabled, onToggle, disabled, title }) => (
  <button
    onClick={onToggle}
    disabled={disabled}
    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none
      ${disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"}
      ${enabled ? "bg-indigo-600" : "bg-gray-300"}`}
    title={title}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform
        ${enabled ? "translate-x-6" : "translate-x-1"}`}
    />
  </button>
);

export default Toggle;
